import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const fontSizes = [32, 24, 20, 16, 14, 12].map(px => px / 16)

const StyledHeadline = styled.div`
  font-size: ${({ level }) => fontSizes[level - 1]}rem;
  font-weight: 700;
`

const Headline = ({ className, level = 1, children }) => {
  return (
    <StyledHeadline as={`h${level}`} level={level} className={className}>
      {children}
    </StyledHeadline>
  )
}

Headline.propTypes = {
  children: PropTypes.node.isRequired,
  level: PropTypes.number.isRequired,
  className: PropTypes.string,
}

export default Headline
